import React from "react"
import Navigation from "../navigation"
import styles from "./liveheader.module.css"
const LiveHeader = (props) => {

    return (
        <div className={styles.container}>
            <Navigation 
                type={props.navigation.type}
                items={props.navigation.items}
            />
            <img 
                src={props.headerImage.imageUri} 
                alt={props.headerImage.imageAltText} 
                className="deskHead" 
                width="100%"/>
            <img 
                src={props.headerImage.imageMobileUril} 
                alt={props.headerImage.imageAltText} 
                className="mobHead" 
                width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
            </div>
        </div>
    )
}

LiveHeader.defaultProps = {
    title: 'SNG Live',
    subTitle: '2020',
    headerImage :{
        imageUri: '',
        imageMobileUril: '',
        imageAltText: ''
    },
    headerImageUri: '',
    headerImageMobileUri: '',
    imageAltText: '',
    navigation: {
        type: 'horizontal',
        items: [],
    }
}
export default LiveHeader